import React from 'react';
import PropTypes from 'prop-types';

import { SuiModalHeader } from '@splashthat/sui';
import styled from 'styled-components';

import { SplashAppTitle } from 'common/components/Typography';

const BASE_CLASS_NAME = 'ScaledFormsModalHeader';

const ModalHeaderStyled = styled(SuiModalHeader)`
    padding: 1rem;
`;

const ScaledFormsModalHeader = ({ headlineTitle, headlineSize }) => (
    <ModalHeaderStyled data-qa={`${BASE_CLASS_NAME}-header`}>
        <SplashAppTitle size={headlineSize} weight="headline" data-qa={`${BASE_CLASS_NAME}__headline-title`}>
            {headlineTitle}
        </SplashAppTitle>
    </ModalHeaderStyled>
);

ScaledFormsModalHeader.propTypes = {
    headlineTitle: PropTypes.string,
    headlineSize: PropTypes.string,
};

ScaledFormsModalHeader.defaultProps = {
    formName: '',
    headlineTitle: '',
    headlineSize: 'large',
};

export default ScaledFormsModalHeader;
